/**
 * Chat service for handling API communication
 */
import axios from 'axios';
import { markdownToHTML } from '@/utils/markdown';

/**
 * Default configuration for chat service
 */
const defaultConfig = {
  apiUrl: 'https://cobalt-v1-92585043467.southamerica-east1.run.app/chat-consultation',
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * Sends a message to the chat API
 * @param {string} message - User message text
 * @param {string} timestamp - Session timestamp
 * @param {Object} config - Optional configuration override
 * @returns {Promise} - API response promise
 */
export async function sendMessage(message, timestamp, config = {}) {
  const apiConfig = { ...defaultConfig, ...config };
  
  try {
    const response = await axios.post(
      apiConfig.apiUrl,
      {
        timestamp: timestamp,
        text: message,
      },
      {
        headers: apiConfig.headers,
      }
    );
    return response;
  } catch (error) {
    console.error('Chat API error:', error);
    throw error;
  }
}

/**
 * Processes API response and formats it for display
 * @param {Object} response - API response object
 * @returns {Object} - Formatted document object
 */
export function processResponse(response) {
  const document = {
    name: "Relatório de produtividade Etanol outubro 2023", // This could be made configurable
    abstract: "",
    link: "https://widelabs.com.br", // This could be made configurable
    tags: ["1", "2", "3", "4"], // This could be made configurable
  };

  if (response && response.data && response.data.text) {
    document.abstract = markdownToHTML(response.data.text);
  }

  return document;
}

